export default __webpack_public_path__ + "static/media/458.c10de060.png";